let activeLeaveGuard = null;

export const registerLeaveGuard = (requestLeaveFunc) => {
    activeLeaveGuard = requestLeaveFunc;
};

export const unregisterLeaveGuard = () => {
    activeLeaveGuard = null;
};

export const requestGuardedAction = (callback) => {
    !activeLeaveGuard ? callback?.() : activeLeaveGuard(callback);
};
